export { default } from "./Pincode";
